import React, { useState } from 'react'
import './experience.css';
import timelineElements from '../../timelineElements';
import { ReactComponent as WorkIcon} from '../../work.svg';
import { ReactComponent as SchoolIcon} from '../../school.svg';
import {
    VerticalTimeline,
    VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";

const Experience = () => {
    let workIconStyles = {background: '#06D6A0'}
    let schoolIconStyles = {background: '#ffeb95'}
    
    // State to track which descriptions are expanded
    const [expandedItems, setExpandedItems] = useState({});
    
    // Function to truncate text
    const truncateText = (text, maxLength = 150) => {
        if (text.length <= maxLength) return text;
        return text.substring(0, maxLength) + '...';
    };
    
    // Function to toggle expanded state
    const toggleExpanded = (id) => {
        setExpandedItems(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    return (
        <div>
            <section id='Experience'>
                <div className='container mt-5'>
                    <div className='text-center mb-4'>
                        <h1>Work <span className="introText">Experience</span></h1>
                    </div>
                    <VerticalTimeline>
                        {       
                            timelineElements.map(element => {
                                let isWorkIcon = element.icon === 'work';
                                const isExpanded = expandedItems[element.id];
                                const displayText = isExpanded ? element.description : truncateText(element.description);
                                
                                return (
                                    <VerticalTimelineElement
                                    key={element.key}
                                    date={element.date}
                                    dateClassName='date'  
                                    iconStyle={isWorkIcon ? workIconStyles : schoolIconStyles}
                                    className={element.id === 4 ? 'education-element' : ''}
                                    icon={isWorkIcon ? <WorkIcon/> : <SchoolIcon/>}
                                    >
                                        <h5 className='vertical-timeline-element-company'>{element.company}</h5>
                                        <h6 className='vertical-timeline-element-title'>{element.title}</h6>
                                        <p className='vertical-timeline-element-description'>{displayText}</p>
                                        {element.description.length > 150 && (
                                            <button 
                                                className='read-more-btn'
                                                onClick={() => toggleExpanded(element.id)}
                                            >
                                                {isExpanded ? 'Read Less' : 'Read More'}
                                            </button>
                                        )}
                                    </VerticalTimelineElement>
                                )
                            })
                        }
                    </VerticalTimeline>
                </div>
            </section>
          
        </div>
    )
}

export default Experience
